import MissionBlock from './MissionBlock';
import JourneyBlock from './JourneyBlock';
import JoinUsBlock from './JoinUsBlock';
import LeaderBlock from './LeaderBlock';
import Information from './Information';

const AboutUs = () => {
  return (
    <>
      <MissionBlock />
      <JourneyBlock />
      <JoinUsBlock />
      <LeaderBlock />
      <Information />
    </>
  );
};

export default AboutUs;
